<template>
  <div class="card m-3 shadow">
    <b-tabs small card>
      <b-tab active class="p-2">
        <template #title>
          <b-icon icon="calendar-date" variant="primary"></b-icon>
          <span class="ms-2">Filtrar por fecha de creación</span>
        </template>
        <KarinDate></KarinDate>
      </b-tab>

      </b-tabs> 
  </div>

</template>
<script>
import KarinDate from '@/components/KarinLaw/KarinFilter/Karin-date.vue'

export default {
  name: 'KarinFilter',

  components: {
    KarinDate,
  }
}
</script>